import styled from '@emotion/styled';
import { COLORS, DOTTED_FOCUS } from '../../constants';

export const StyledLessonIcon = styled.span<{
  margin?: string;
}>`
  display: inline-flex;
  margin: ${({ margin }) => margin};
`;

export const StyledCustomLessonIcon = styled.button<{
  color?: string;
}>`
  display: inline-flex;
  border: none;
  border-radius: 50%;
  background: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  transition: fill 0.35s;

  :hover,
  :active,
  :focus {
    path[stroke='${({ color }) => color}'] {
      fill: ${({ color }) => color};
    }

    path[fill='${({ color }) => color}']:not(.static) {
      fill: ${COLORS.white};
    }

    path[fill='white'] {
      fill: ${({ color }) => color};
    }
  }

  ${DOTTED_FOCUS}
`;
